'use client';
import { Typography } from '@curology/ui-components-web/react';
import { Link } from '@curology/ui-components-web/react/Link';
import React from 'react';

import { SocialSignupButtons } from '@/components/flow/components/SocialSignupButtons/SocialSignupButtons';

export const CreateAccountLinks = () => {
  return (
    <React.Fragment>
      <div className="cur-mb-4">
        <SocialSignupButtons />
      </div>
      <Typography className="cur-text-center">
        Already have a Curology account?{' '}
        <Link className="cur-font-bold" href="/auth/login">
          Log in
        </Link>
      </Typography>
    </React.Fragment>
  );
};
